<app-form [form]="form" (ngSubmit)="onSubmitLogin()" [features]="{write:true}">
    
    <app-form-control [(control)]="form.controls.usernameOrEmail" [type]="'email'"/>
    <app-form-control [(control)]="form.controls.password" [type]="'password'"/>

    <div class="d-flex flex-row align-items-start gap-2">
        <app-form-control [(control)]="form.controls.remember" [type]="'checkbox'"/>
        <fa-icon class="font-size-08rm color--text-primary-60" [icon]="['far', 'circle-info']" [tooltip]="'Remember Log-In for 24 hours.'"/>
    </div>

    <app-modal-form-button-group [buttons]="['submit']" [form]="form" 
        [opts]="{
            values:{
                submit: 'Log-In'
            }
        }"
    />

</app-form>
    
<app-login-tfa-modal [(visible)]="showTFA" (login)="onSubmitLoginTFA($event)"/>